import { select } from '@js/util/select.js'
import $ from 'jquery'

/*******************************
 * Countdown
 ******************************/

select('.slider-integrated .swiper .slider-countdown', element => {
  let $countdown = $(element)
  let $ancestor = $countdown.closest('[data-countdown]')
  let $swiper = $(element).closest('.swiper')

  let date = $ancestor.data('countdown')
  let timestamp = $ancestor.data('countdown-ms')

  if (typeof timestamp !== 'number') return

  let browserDate = new Date(date)
  let diff = timestamp - browserDate.getTime()

  let remainingMs = timestamp - Date.now() - diff

  let assembleCountdownHtml = () => {
    remainingMs = timestamp - Date.now() - diff

    let days = Math.floor(remainingMs / (1000 * 60 * 60 * 24))
    let hours = Math.floor((remainingMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    let minutes = Math.floor((remainingMs % (1000 * 60 * 60)) / (1000 * 60))
    let seconds = Math.floor((remainingMs % (1000 * 60)) / 1000)

    let html = ''

    let showDays = days > 0
    if (showDays) {
      html +=
        `<span class="countdown-value">${String(days).padStart(2, '0')}</span>` +
        `<span class="countdown-label">Tage</span>` +
        `<span class="countdown-colon">:</span>`
    }

    let showHours = hours > 0 || showDays
    if (showHours) {
      html +=
        `<span class="countdown-value">${String(hours).padStart(2, '0')}</span>` +
        `<span class="countdown-label">Stunden</span>` +
        `<span class="countdown-colon">:</span>`
    }

    let showMinutes = minutes > 0 || showHours
    if (showMinutes) {
      html +=
        `<span class="countdown-value">${String(minutes).padStart(2, '0')}</span>` +
        `<span class="countdown-label">Minuten</span>` +
        `<span class="countdown-colon">:</span>`
    }

    let showSeconds = seconds > 0 || showMinutes
    if (showSeconds) {
      html +=
        `<span class="countdown-value">${String(seconds).padStart(2, '0')}</span>` +
        `<span class="countdown-label">Sekunden</span>`
    }

    return html
  }

  let intervalId = setInterval(() => {
    let html = assembleCountdownHtml()

    if (remainingMs <= 0) {
      clearInterval(intervalId)
      $swiper
        .prop('swiper')
        .removeSlide($countdown.closest('.swiper-slide').data('swiper-slide-index'))
    } else {
      $countdown.html(html)
    }
  }, 1000)
  $countdown.html(assembleCountdownHtml())
})
